export const CAL_PLUS_FEATURES = {
  customizedScreensaver: {
    heading: 'Photo Screensaver',
    text: `Turn your Calendar into a photo frame when it's not in use! Upload photos with our app.`,
  },
  mealPlanning: {
    heading: 'Meal Planning',
    text: `Never answer, “What are we eating?” again! Plan the week's meals in just 5 minutes.`,
  },
  magicImport: {
    heading: 'Magic Import',
    text: `Forward any email or PDF from school and we’ll convert it into events on your calendar.`,
  },
}
export const PRODUCT_DROPDOWN_LABELS = {
  27: {
    label: `27" Calendar Max`,
  },
  15: {
    label: `15" Calendar`,
  },
  10: {
    label: `10" Calendar`,
  },
}

export const SPLIT_PRICE = {
  27: {
    Classic: '149.99',
    default: '157.49',
  },
  10: {
    default: '42.49',
  },
  15: {
    default: '74.99',
  },
}

export const CAL_PLUS_PRICING = {
  en: {
    10: {
      regularPrice: '159.99',
      withoutPlus: '119.99',
      withPlus: '109.99',
    },
    15: {
      regularPrice: '299.99',
      withoutPlus: '249.99',
      withPlus: '239.99',
    },
  },
  en_ca: {
    15: {
      regularPrice: '440.00',
      withoutPlus: '370.00',
      withPlus: '355.00',
    },
  },
  en_au: {
    15: {
      regularPrice: '499.00',
      withoutPlus: '399.00',
      withPlus: '379.00',
    },
  },
  en_gb: {
    15: {
      regularPrice: '280.00',
      regularPriceWithoutPlus: '290.00',
      withoutPlus: '246.50',
      withPlus: '238.00',
    },
  },
}

export const CAL_SIZE_PRICING = {
  10: {
    bubble: '$30 OFF',
    regularPrice: '169.99',
    discountedPrice: '139.99',
  },
  15: {
    bubble: '$30 OFF',
    regularPrice: '299.99',
    discountedPrice: '269.99',
  },
  27: {
    bubble: '',
    regularPrice: '599.99',
    discountedPrice: '',
  },
}
